import React from 'react';
import { defaultMarkdownRenderers } from './defaultMarkdownRenderers';

export const MarkdownRenderContext = React.createContext(
	defaultMarkdownRenderers,
);
